import React from 'react'
import { Badge, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Str from '../../support/Str';
import { Auth } from '../../support';
import NavLink from '../components/NavLink';
import { Guardian } from '@xaamin/guardian';
import Tenancy from '../../shared/tenancy/Tenancy';
import Loading from '../../facturotopia/loading/Loading';

const AdditionalModulesSidebar = ({ live, busy, onMenuItemClick, onCompanyClick, onTenancyChange, ...rest }) => {
  const { empresa = {} } = Auth.getData() || {};

  const sidebarContainerClassName = 'sidebar-container ' + (!!live ? 'live': '');

  return (
    <div className={ sidebarContainerClassName }>
      <div className="scrollbar">
        <Nav className="flex-column">

          <Nav.Link as="div" eventKey="tenancy" to="#tenancy" className="tenancy-link my-3">
            { busy && <Loading /> }

            { !busy && (
                <Tenancy live={ live } onTenancyChange={ onTenancyChange } />
              )
            }
          </Nav.Link>

          <Nav.Link as="div"
            eventKey="company"
            to="/app/switch"
            className="nav-link-company"
            onClick={ onCompanyClick }
          >
            <div className="company">
            { Str.only(empresa.nombre, 18) }
              <span className="float-right pr-3">
                <FontAwesomeIcon icon={ ['fas', 'exchange-alt'] } />
              </span>
            </div>
          </Nav.Link>

          <Nav.Link eventKey="disabled" disabled className="divider-simple"></Nav.Link>

          <Nav.Link as={ NavLink } eventKey="dashboard" to="/app/dashboard" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['fas', 'tachometer-alt'] } />
            <span className="nav-link-text">Dashboard</span>
          </Nav.Link>

          { Guardian.allows('facturacion_masiva.access') && (
            <Nav.Link as={ NavLink } eventKey="dashboard" to="/modulos/timbrado-masivo" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">Facturación por excel</span>
            </Nav.Link>
          )}

          { Guardian.allows('retencion_masiva.access') && (
            <Nav.Link as={ NavLink } eventKey="dashboard" to="/modulos/retenciones-masivas" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">Retenciones por excel</span>
            </Nav.Link>
          )}

          { Guardian.allows('autofacturacion.access') && (
            <Nav.Link as={ NavLink } eventKey="comprobantes" to="/modulos/autofacturacion" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">Autofacturación</span>
            </Nav.Link>
          )}

          { Guardian.allows('facturacion_masiva.access') && (
            <Nav.Link as={ NavLink } eventKey="cancelaciones" to="/modulos/cancelaciones" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">
                Cancelaciones
                <Badge variant="danger" className="beta-badge">BETA</Badge>
              </span>
            </Nav.Link>
          )}

          { Guardian.allows('socios_de_negocio.access') && (
            <Nav.Link as={ NavLink } eventKey="socios" to="/modulos/socios" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">
                Socios de Negocios
              </span>
            </Nav.Link>
          )}

          { Guardian.allows('timbrado_sftp.access') && (
            <Nav.Link as={ NavLink } eventKey="timbrado-sftp" to="/modulos/timbrado-sftp" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">
                Timbrado Sftp
              </span>
            </Nav.Link>
          )}

          { Guardian.allows('catalogo_cliente.access') && (
            <Nav.Link as={ NavLink } eventKey="catalogo-cliente" to="/modulos/catalogo-cliente" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">
                Catálogo Cliente
              </span>
            </Nav.Link>
          )}

          { Guardian.allows('recepcion.access') && (
            <Nav.Link as={ NavLink } eventKey="recepcion" to="/modulos/recepcion" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">
                Recepción
              </span>
            </Nav.Link>
          )}

          <Nav.Link eventKey="disabled" disabled>
            Tickets
          </Nav.Link>

          {/* { Guardian.allows('facturacion_masiva.access') && (
            <Nav.Link as={ NavLink } eventKey="hits" to="/modulos/timbrado-masivo/tickets" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['far', 'copy'] } />
              <span className="nav-link-text">Facturación masiva</span>
            </Nav.Link>
          )} */}

          { Guardian.allows('autofacturacion.access') && (
            <>
              {/* <Nav.Link as={ NavLink } eventKey="retenciones" to="/modulos/tickets/autofacturacion" onClick={ onMenuItemClick }>
                <FontAwesomeIcon icon={ ['far', 'copy'] } />
                <span className="nav-link-text">Autofacturación</span>
              </Nav.Link> */}

              <Nav.Link as={ NavLink } eventKey="retenciones" to="/modulos/fpg" onClick={ onMenuItemClick }>
                <FontAwesomeIcon icon={ ['far', 'copy'] } />
                <span className="nav-link-text">Factura Global</span>
              </Nav.Link>
            </>
          )}

        </Nav>
      </div>
    </div>
  )
}

export default AdditionalModulesSidebar